import { IProductType } from "src/type/product"
import {isEmpty} from 'lodash'
import { formatDate } from "src/core/i18n/date"
import { IPage } from "src/type/page"
import ReactHtmlParser from 'react-html-parser'
import { IAddress } from "src/type/address"
import * as moment from "moment"

export function getFileExtension(string){
    const ext = /[^.]+$/.exec(string)![0]
    switch(ext.toLowerCase()){
        case "ppsx": 
            return 'pptx';
        default:
            return ext.toLowerCase();
    }
}

export const acceptedFiles = ".bmp,.dib,.jpeg,.jpg,.jpe,.jfif,.gif,.tif,.tiff,.png,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pps,.ppsx,.pdf,.txt,.xml,.mp3,.mp4,.zip"
export const acceptedDocuments = ".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pps,.ppsx,.pdf,.txt,.xml"
export const acceptedImages = ".bmp,.dib,.jpeg,.jpg,.jpe,.jfif,.gif,.tif,.tiff,.png"
export const acceptedVideos = ".mp3,.mp4"


const mimesToExt = {
    "text/html": "html",
    "text/css": "css",
    "text/xml":"xml",
    "image/gif":"gif",
    "image/jpeg":"jpg",
    "application/x-javascript":"js",
    "text/plain":"txt",
    "image/png":"png",
    "image/tiff":"tiff",
    "image/x-icon":"file",
    "image/x-ms-bmp":"bmp",
    "application/msword":"doc",
    "application/pdf":"pdf",
    "application/postscript":"ai",
    "application/rtf":"rtf",
    "application/vnd.ms-excel":"xls",
    "application/vnd.ms-powerpoint":"ppt",
    "application/x-rar-compressed":"rar",
    "application/xhtml+xml":"html",
    "application/zip":"zip",
    "audio/mpeg":"mp3",
    "video/mpeg":"mpg",
    "video/quicktime":"mov",
    "video/x-flv":"flv",
    "video/x-msvideo":"avi",
    "video/mp4":"mp4",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx"
};

export function getExtensionFromContentType(content_type) {
    if (mimesToExt.hasOwnProperty(content_type)) {
        return mimesToExt[content_type];
    }

    return "file";
}

export function getUserBestName(user){
    if(user){
        if(user.first_name && user.last_name){
            return user.first_name + " " + user.last_name
        }else if(user.first_name) {
            return user.first_name;
        } else if(user.last_name){
            return user.last_name;
        } else {
            return user.email;
        }
    } else {
        return "-"
    }
}


export function getUserBestNameWithoutEmail(user){
    if(user){
        if(user.first_name && user.last_name){
            return user.first_name + " " + user.last_name
        }else if(user.first_name) {
            return user.first_name;
        } else if(user.last_name){
            return user.last_name;
        } else {
            return "-";
        }
    } else {
        return "-"
    }
}

export function convertUrlName(string){
    return encodeURIComponent(string.toString().toLowerCase().trim().replace(/\s+/g, '-'))
}

export function isValidDate(value){
    return moment(new Date(value)).isValid()
}

export function slugify(text) {
    const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    const to   = "aaaaaeeeeeiiiiooooouuuunc------";
    for (let i = 0, len = from.length; i < len; i++) {
        text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    return text
        .toString()                     // Cast to string
        .toLowerCase()                  // Convert the string to lowercase letters
        .trim()                         // Remove whitespace from both sides of a string
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/&/g, '-y-')           // Replace & with 'and'
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-');        // Replace multiple - with single -
}

export function varSlugify(text) {
    const from = "ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;";
    const to   = "aaaaaeeeeeiiiiooooouuuunc------";
    for (let i = 0, len = from.length; i < len; i++) {
        text = text.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }
    return text
        .toString()                     // Cast to string
        .toLowerCase()                  // Convert the string to lowercase letters
        .trim()                         // Remove whitespace from both sides of a string
        .replace(/\s+/g, '_')           // Replace spaces with -
        .replace(/&/g, '-y-')           // Replace & with 'and'
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '_');        // Replace multiple - with single -
}

export function arraySlugify(arr){
    return arr.map(ele => slugify(ele))
}

export function arraySlugifyToString(arr){
    return arr.map(ele => slugify(ele)).join()
}

export function mapSlugToName(categories: any){
    const nameCategories = [].concat.apply([],categories.map(c => c.sub_categories))
    const mapSlugCategories = new Map();
    nameCategories.map(n => {
        mapSlugCategories.set(slugify(n), n)
    })
    return mapSlugCategories;
}

export function getIdFormYoutubeUrl(url){
    let ID = '';
    url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if(url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_\-]/i);
      ID = ID[0];
    }
    else {
      ID = url;
    }
      return ID;
}

export function mapValuesContractual(values){
    return values ? {
        person_to_notify_email: values.person_to_notify_email,
        person_to_notify_first_name: values.person_to_notify_first_name,
        person_to_notify_last_name: values.person_to_notify_last_name,
        person_to_notify_address: {
          number: values.number,
          street: values.street,
          country: values.country,
          zip: values.zip,
          city: values.city,
        },
        emir_status: values.emir_status,
        ...(values.lei && {lei: values.lei}),
        ...(values.rcs_city_legal_representative && {rcs_city_legal_representative: values.rcs_city_legal_representative}),
        ...(values.siren_legal_representative && {siren_legal_representative: values.siren_legal_representative}),
        ...(values.rcs_city && {rcs_city: values.rcs_city}),
        ...(values.siren && {siren: values.siren})
    } : {}
}

export function buildMapProductType(productTypes: IProductType[]){
    const mapProductType = new Map();
    productTypes.map(pt => {
        mapProductType.set(pt.value, pt.label)
    })
    return mapProductType;
}

export function generateText(data: any, value: string, label: string){
    return data && data[value] ? data[value] : "?"
} 

export function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

export function formatCurrency(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
}

export function isDate(date: any) {
    return isNaN(date) && !isNaN(Date.parse(date))
}

export function parseNumber(numberType: string, value: any){
    switch(numberType){
        case 'float':
            return value ? parseFloat(value) : value
        case 'int':
            return value ? parseInt(value,10) : value
        default:
            return value
    }
}

export function checkExistValuesForm(form: any, valuesCheck: string[]){
    if(valuesCheck.length > 0){
        const errors = {};
        valuesCheck.map(v => {
            if(form[v] === undefined){
                errors[v] = `${v} undefined`
            }
        })
        return isEmpty(errors) ? true : false
    } else {
        return true
    }
}

export  function generateDevise(sens: string, devise: string){
    switch(sens){
        case 'import':
            return ` (Achat ${devise.toString().substring(4)})`;
        case 'export':
            return ` (Vente ${devise.toString().substring(4)})`;
        default:
            return ''
    }
}

export function generateTableCell(value: any, cellType?: string){
    if(value === null || value === undefined || value.length === 0){
        return '-'
    } else {
        if(cellType){
            switch(cellType){
                case 'date':
                    return formatDate(new Date(value))
                case 'currency': 
                    return formatCurrency(value)
                case 'boolean':
                    return value === true ? 'Oui': 'Non'
                default:
                    return value
            }
        } else {
            return value
        }
    }
}

export function getCurrencyInDevises(devise: string){
    return devise ? devise.replace('EUR/','') : '?'
}

export const boolToValue = (bool: boolean): string => {
    return bool ? "yes" : "no"
};

export function cotationAssign(assign: string){
    switch(assign){
        case "arkea":
            return "ARKEA";
        case "client":
            return "client";
        default: 
            return ""
    }
}

export function cotationStatus(status: string){
    switch(status){
        case 'LIVE':
            return "En cours";
        case 'EXPIRED':
            return "Expirée";
        case 'DONE':
            return "Finalisée";
        case 'DRAFT':
            return "Brouillon";
        default: 
            return "-"
    }
}

export const SeoContent = (page: IPage) => (page.data ? ReactHtmlParser(page.data) : '')

export function generateAdresseFormObj(values: IAddress){
    const street = values.street ? " " + values.street : ""
    const city = values.city ? ", " + values.city : ""
    const country = values.country ? ", " + values.country : ""
    return values.number + street + city + country
}

export function capitalizeFirstLetter(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export function convertSlugToName(categoriesDispo: any, categories: any, slugs: any){
    /*  
        Create list name categories dispo. 
        Exp: ["veille éco", "PME", "Hebdo", ...]
    */
    let nameCategories: any = null;
    nameCategories = [].concat.apply([],categories.filter(x => categoriesDispo.includes(x.slug)).map(c => c.sub_categories))

    /* 
        Create a map of categories dispo. 
        Exp: [{"pme" => "PME"}, {"hebdo" => "Hebdo"}, {"points" => "Points"}, ...] 
    */
    const mapSlugCategories = new Map();
    nameCategories.map(n => {
        mapSlugCategories.set(slugify(n), n)
    })

    /* 
        Convert slug to name. 
        Exp: ["pme", "hebdo", "points", ...] => ["PME", "Hebdo", "Points", ...] 
    */
    const rebuildSlugToName: any[] = [];
    slugs.map(el => {
        if(mapSlugCategories.get(el) !== undefined){
            rebuildSlugToName.push(mapSlugCategories.get(el))
        } else {
            slugs.splice(slugs.indexOf(el), 1)
        }
    })
    return rebuildSlugToName;
}


export function createPaths(map, path, value) {
  if(typeof path === "string") {
        path = path.split(".");
    }
  if(path.length === 1) {
    map[path[0]] = value;
    return;
  } else {
    if(!(path[0] in map)) {
            map[path[0]] = {};
        }
    return createPaths(map[path[0]], path.slice(1), value);
  }
}

export function restrictCurrenciesExchange(valuesAvailable, currenciesExchange) {
    if(valuesAvailable && valuesAvailable !== "EUR"){
        const condition = valuesAvailable.split(",").filter(v => v !== "EUR");
        return currenciesExchange.filter(currency => condition.includes(currency.replace('EUR/','')));
    } else {
        return currenciesExchange
    }
}

export function replaceDetteWithTaux(string){
    const labelToSwitch = {
        Focus: "Focus Actu",
        Hebdo: "Hebdo Eco",
        Perspectives: "Perspectives Eco",
        Points: "Tendances Marché",
        "PME dette": "Flash Taux",
        "PME placement": "Flash Placement",
        "PME change": "Flash Change",
        "PME Dette": "Flash Taux",
        "PME Placement": "Flash Placement",
        "PME Change": "Flash Change",
        Dette: "Taux",
        dette: "taux"
    }
    return labelToSwitch[string] ? labelToSwitch[string] : string;
}

export function replaceTauxWithDette(string){
    const labelToSwitch = {
        "Focus Actu": "Focus",
        "Hebdo Eco": "Hebdo",
        "Perspectives Eco": "Perspectives",
        "Tendances Marché": "Points",
        "Flash Taux": "PME dette",
        "Flash Placement": "PME placement",
        "Flash Change": "PME change",
        Taux: "Dette",
        taux: "dette"
    }
    return labelToSwitch[string] ? labelToSwitch[string] : string;
}


// WEBPACK FOOTER //
// ./src/shared/utils/helpers.ts